class MFRCarouselReveal {
    constructor( i, e ) {
        this.$index = i;
        this.$element = $( e );

        this.selectors = {
          carousel: ".nutrition-facts-modal__carousel",
          slide: ".nutrition-facts-modal__slide"
        };

        this.init();
    }

    init() {
        this.$carousel = this.$element.find( this.selectors.carousel );
        this.$slide = this.$element.find( this.selectors.slide );

        this.$element.on("open.zf.reveal", this.__handleRevealOpen.bind( this ) );
    }

    __handleRevealOpen( e ) {
        if( !this.$slide.length ) return;
        
        if (!this.$carousel.hasClass("flickity-enabled")) {
        this.$carousel.flickity({
            selectedAttraction: 0.1,
            friction: 0.55,
            prevNextButtons: false,
            contain: true,
            cellAlign: "center",
            pageDots: true,
            wrapAround: true,
            imagesLoaded: true,
        });
        } else {
        this.$carousel.flickity("resize");
        }
    }
}